@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/mixins/common" as m;
@use "styles/abstracts/variables" as v;

$grid-cols: 160px 160px 120px 120px 120px 120px 80px 170px 1fr;
$grid-cols-scroll: 160px 160px 120px 120px 120px 120px 80px 170px 0px;
$table-min-width: 0px;

.table {
  margin-bottom: 16px;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  @include m.media(v.$container-desktop, "min") {
    overflow-x: visible;
  }

  .select {
    > div {
      border: 1px solid transparent;
    }
  }
}

.menu {
  width: 360px;
  height: 236px;
}

.menuPortal {
  @include m.media(v.$container-tablet, "min") {
    min-width: 295px;
  }
}

.header {
  display: grid;
  grid-template-columns: $grid-cols-scroll;
  min-width: $table-min-width;
  width: auto;

  @include m.media(v.$container-desktop, "min") {
    grid-template-columns: $grid-cols;
    min-width: 0;
    width: 100%;
  }
}

.headerCell {
  padding: 14px 16px;
  text-align: left;
  white-space: nowrap;
  @include t.text(14px, 22px, 600);
  color: v.$default-text-color;
  transition: color 300ms ease;
}

.headerCellError {
  color: v.$color-error;
}

.row {
  display: grid;
  grid-template-columns: $grid-cols-scroll;
  min-width: $table-min-width;
  width: auto;

  @include m.media(v.$container-desktop, "min") {
    grid-template-columns: $grid-cols;
    min-width: 0;
    width: 100%;
  }
}

.rowWrap {
  min-width: $table-min-width;
  width: auto;

  @include m.media(v.$container-desktop, "min") {
    min-width: 0;
    width: 100%;
  }
}

.palletError {
  padding: 0 8px 8px;
  border-top: none;
}

.palletErrorInfo {
  width: 100%;
  @include t.text(13px, 20px, 400);
}

.cell {
  display: flex;
  align-items: center;
  padding-right: 2px;
  height: 50px;
  min-width: 0;

  &.tdColor {
    padding: 14px 16px;
  }

  &.tdActions {
    padding: 0;
    justify-content: flex-end;
  }
}

.actionsBox {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0;
  width: 100%;
}

.actionBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 50px;
  padding: 0;
  flex-shrink: 0;
}

.numberInput {
  &::placeholder {
    color: v.$palette-dirty-70;
  }

  &.placeholderError::placeholder {
    color: v.$color-error;
  }
}
